import { render, staticRenderFns } from "./_Main.vue?vue&type=template&id=f85c4090&scoped=true&"
import script from "./_Main.vue?vue&type=script&lang=js&"
export * from "./_Main.vue?vue&type=script&lang=js&"
import style0 from "./_Main.vue?vue&type=style&index=0&id=f85c4090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85c4090",
  null
  
)

export default component.exports